import { Injectable } from '@angular/core';

declare var tl;
const pageGuideKey: string = 'PAGE_GUIDE_DISMISSED';

@Injectable({
	providedIn: 'root'
})
export class PageGuideService {

	private internalPageGuideVerification: boolean = false;

	constructor() { }

	startPageGuide() {
		
		let pageGuideStarted: boolean = (localStorage.getItem('pageGuide') === 'true');

		if (!pageGuideStarted && !this.internalPageGuideVerification) {
			tl.pg.init({
				check_welcome_dismissed: () => {
					if (this.isPageGuideDismissed())
						return true;

					return false;
				},
				dismiss_welcome: () => {
					localStorage.setItem(pageGuideKey, '1');
				},
				auto_refresh: true,
				handle_doc_switch: (current: string, previous: string) => {
					const firstSelect: string = '.first_element_to_target';
					if (current == firstSelect) {
						let firstElement = document.querySelector(firstSelect) as HTMLElement;
						firstElement.click();
					}
				},

				pg_caption: "Tour Guiado"
			});
			this.internalPageGuideVerification = true;
			localStorage.setItem('pageGuide', 'true');
		}
	}

	shutdownPageGuide() {

		tl.pg.destroy();
		this.internalPageGuideVerification = false;
		localStorage.setItem('pageGuide', 'false');
	}

	isPageGuideDismissed() {

		return localStorage.getItem(pageGuideKey);
	}

	getInternalPageGuideVerification(): boolean {
		
		return this.internalPageGuideVerification;
	}

	get isPageGuideActive(): boolean {

		let pageGuide: HTMLElement = document.querySelector('div.tlypageguide_toggle.tlyPageGuideToggleActive');

		if (!pageGuide)
			return false;

		return true;
	}
}